import { useEffect, useRef } from "react";

/**
 * Allows you to reference a given previous value before updating to current in the next render.
 */
export default function usePrevious(value) {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}
